import LoginForm from './LoginForm';
import SignupForm from './SignupForm';import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Auth = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [isSignup, setIsSignup] = useState(true);

  const handleSignupSuccess = (userData) => {
    if (onLoginSuccess) {
      onLoginSuccess(userData.user);
    }
    setTimeout(() => navigate('/home'), 1500);
  };

  const handleLoginSuccess = (userData) => {
    if (onLoginSuccess) {
      onLoginSuccess(userData);
    }
    setTimeout(() => navigate('/home'), 1500);
  };

  const handleModeChange = (newMode) => {
    setIsSignup(newMode);
  };

  return (
    <div className="auth-container">
      <div className="auth-main-container">
        {/* Header */}
        <div className="auth-header">
          <div className="auth-logo">
            <span
              className="logo"
              style={{
                display: 'inline-block'
              }}
            ></span>
          </div>
          <h1 className="auth-title">AastroG</h1>
          <p className="auth-subtitle">✨ Your Personal Astro Guru ✨</p>
        </div>

        {/* Toggle */}
        <div className="auth-toggle">
          <button
            onClick={() => handleModeChange(true)}
            className={`toggle-btn ${isSignup ? 'active' : ''}`}
          >
            📝 Sign Up
          </button>
          <button
            onClick={() => handleModeChange(false)}
            className={`toggle-btn ${!isSignup ? 'active' : ''}`}
          >
            🔑 Login
          </button>
        </div>

        {/* Forms */}
        {isSignup ? (
          <SignupForm
            onSignupSuccess={handleSignupSuccess}
            onNeedLogin={() => handleModeChange(false)}
          />
        ) : (
          <LoginForm
            onLoginSuccess={handleLoginSuccess}
            onNeedSignup={() => handleModeChange(true)}
          />
        )}
      </div>

      {/* Copyright */}
      <div className="auth-copyright">
        • Secure Authentication • Activation Required
      </div>
    </div>
  );
};

export default Auth;
